/**
 * Mixin for selectize components.
 */

const mixin = {
  mounted: function () {
    if (window && window.Selectize && window.Selectize.$testInput) {
      window.Selectize.$testInput.attr("aria-hidden", "true");
    }
  },
  methods: {
    /**
     * Format option ID to lowercase kebab-case
     * Replace all special characters and spaces to hyphen.
     * @returns string
     */
    _formatOptionId: function (text) {
      if (text && text !== "") {
        const str = text
          .replace(/[^a-zA-Z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "")
          .replace(/-+/g, "-")
          .toLowerCase();
        return "select-option-" + this.id + "-" + str;
      }

      return text;
    }
  }
};

export default mixin;
